import React from "react";
type ProgressRingProps = {
  value: number;
  label: string;
  size?: "sm" | "md" | "lg";
  color?: string;
};
export function ProgressRing({
  value,
  label,
  size = "md",
  color = "#55ba5a"
}: ProgressRingProps) {
  const sizePx = size === "sm" ? 64 : size === "lg" ? 128 : 96;
  const stroke = size === "sm" ? 7 : 9;
  const radius = (sizePx - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - value / 100 * circumference;
  return <div className="relative grid place-items-center" style={{
    height: sizePx,
    width: sizePx
  }} aria-label={`${label}: ${value}%`} data-id="element-327" data-mp="39tmsh9m3dl44">
      <svg className="absolute inset-0 -rotate-90" viewBox={`0 0 ${sizePx} ${sizePx}`} aria-hidden="true" data-id="element-328" data-mp="3dwazrcv5qjyz">
        <circle cx={sizePx / 2} cy={sizePx / 2} r={radius} fill="none" stroke="#d8dbe3" strokeWidth={stroke} data-id="element-329" data-mp="3it1fu06ypfke" />
        <circle cx={sizePx / 2} cy={sizePx / 2} r={radius} fill="none" stroke={color} strokeWidth={stroke} strokeLinecap="round" strokeDasharray={circumference} strokeDashoffset={offset} data-id="element-330" data-mp="1jirwrnicy96a" />
      </svg>
      <span className="relative text-lg font-bold tracking-[-0.04em] text-[#32354f]" data-id="element-331" data-mp="19b153fzxqub4">{value}%</span>
    </div>;
}